import { Consignment } from '@bigcommerce/checkout-sdk';

import { storage } from '../utils'

interface CustomCheckoutWindow extends Window {
    B2B_ENV?: string
  }
  
const customCheckoutWindow: CustomCheckoutWindow = window as CustomCheckoutWindow

const env: string = customCheckoutWindow?.B2B_ENV === 'staging' ? 'staging' : customCheckoutWindow?.B2B_ENV || 'production'

interface CustomShippingOptionsType {
    staging: string,
    production: string
    [key: string]: string
}

const customShippingOptions = {
    'staging': 'carrier_373',
    'production': 'carrier_372',
}

const setShippingOptions = async (props: any) => {
    const { consignments } = props;
    const quoteShippingMethods = storage.quoteShippingMethods.getValue() ? JSON.parse(storage.quoteShippingMethods.getValue()) : ''

    if ((consignments as Consignment[]).length && quoteShippingMethods?.id) {
        const { availableShippingOptions, id } = (consignments as Consignment[])[0];
        const { selectShippingOption, setFieldValue } = props;

        if (availableShippingOptions && availableShippingOptions.length > 1) {
            await selectShippingOption(id, quoteShippingMethods.id);
            setFieldValue(`shippingOptionIds.${id}`, quoteShippingMethods.id);
        }
    }
}

const convertShippingAddress = (address: any) => {
    return {
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        company: address.company,
        country: address.country,
        countryCode: address.countryCode,
        customFields: address.customFields,
        email: '',
        firstName: address.firstName,
        lastName: address.lastName,
        phone: address.phone,
        postalCode: address.postalCode,
        shouldSaveAddress: address.shouldSaveAddress,
        stateOrProvince: address.stateOrProvince || '',
        stateOrProvinceCode: address.stateOrProvinceCode,
    }
}


const b2bSetCustomShippingOptions = (consignments: Consignment[]) => {
    const type = (customShippingOptions as CustomShippingOptionsType)[env] || 'carrier_372';
    const newConsignments = consignments.map((item: Consignment) => {
        if (item?.availableShippingOptions && item?.availableShippingOptions?.length ) {
            const availableShippingOptions = item.availableShippingOptions.filter((option => option.type.includes(type)))

            if (availableShippingOptions.length) {
                item.availableShippingOptions = availableShippingOptions
            }

            return item
        }

        return item
    })

    return newConsignments
}

export default {
  setShippingOptions,
  convertShippingAddress,
  b2bSetCustomShippingOptions,
}
